import { ChangeDetectionStrategy, Component, Inject, PLATFORM_ID,OnInit  } from '@angular/core';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core'; 
import {MatIconModule} from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-training-attandance-entry',
  standalone: true,
  imports: [
    CommonModule,
    MatSelectModule, MatInputModule, MatFormFieldModule, MatCheckboxModule, 
    MatDatepickerModule, MatNativeDateModule, MatIconModule, MatRadioModule, 
    FormsModule,  MatDialogModule, MatButtonModule, ReactiveFormsModule
  ],
  templateUrl: './training-attandance-entry.component.html',
  styleUrl: './training-attandance-entry.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TrainingAttandanceEntryComponent implements OnInit{
  message: any = null;
  messagetwo: any = null;
  messagereturn: any = null;
  isBrowser = false;
  trainingForm: FormGroup;
  // Separate file name holders
  materialFileName: string = '';
  envionmentFileName: string = '';
  foodFileName: string = '';
   // To store actual file objects
  selectedFiles: { [key: string]: File } = {};

  participants = [
    { id: 1, name: 'Arun Mondal', attendance: '' },
    { id: 2, name: 'Anjali Kundu', attendance: '' },
    { id: 3, name: 'Bithika Biswas', attendance: '' },
    { id: 4, name: 'Doli Das', attendance: '' },
    { id: 5, name: 'Ranjana Bose', attendance: '' },
    { id: 6, name: 'Soma Dey', attendance: '' },
  ];
  attdate!: Date;
  constructor(
    private fb: FormBuilder,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: { id: number, fdate:string },
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
     //this.attdate=data.fdate;
      this.isBrowser = isPlatformBrowser(this.platformId);

      this.trainingForm = this.fb.group({
        materialFile: [null],
        environmentFile: [null],
        foodFile: [null]
      });
    }
    ngOnInit(): void {
    // ✅ Convert incoming string to Date object
    this.attdate = new Date(this.data.fdate);

    // Optional: fallback if date is invalid
    if (isNaN(this.attdate.getTime())) {
      this.attdate = new Date();
    }
  }
    // Select file
    onFileSelected(event: any, controlName: string) {
  const file = event.target.files[0];
  if (file) {
    this.selectedFiles[controlName] = file;
    this.trainingForm.patchValue({ [controlName]: file });

    if (controlName === 'materialFile') {
      this.materialFileName = file.name;
    } 
    else if (controlName === 'environmentFile') {
      this.envionmentFileName = file.name;
    } 
    else if (controlName === 'foodFile') {
      this.foodFileName = file.name;
    }
  }
}


 

 /* saveAttendance() 
  {
    console.log(this.participants);
    alert();
    // Example output:
    // [{id:1, name:"Arun Mondal", attendance:"Yes"}, ...]
  }*/
}
